import React from 'react';

import { useForm } from 'react-hook-form';
import { Button, InputAdornment } from '@mui/material';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';

import { LbInput, LbSelect } from '@infoods/lifebase-ui';
import classes from './TitleFilterRow.module.scss';
import { EntitySubscriptionsFilterFormValue } from '../../../../interfaces/entitySubscriptionFilters';
import { useAutoSubmitForm } from '../../../../../shared/hooks/useAutoSubmitForm';

import { scanIqSubscriptionsManagementStore } from '../../../../stores/entitySubscriptionsManagementStore';
import { billingPeriodTypeOptionsWithAll } from '../../../../constants/billingPeriodType';

type TitleFilterRowProps = {
  toggleShowCreateSubscriptionModal: () => void;
};

const TitleFilterRow = ({ toggleShowCreateSubscriptionModal }: TitleFilterRowProps) => {
  const { control, handleSubmit, watch } = useForm<EntitySubscriptionsFilterFormValue>();

  useAutoSubmitForm(
    handleSubmit((data) => {
      scanIqSubscriptionsManagementStore.filterMethods.applyFilters(data);
    }),
    watch,
    ['generalFilter.name'],
  );

  const generalInputProps = { control, variant: 'outlined', size: 'small' } as const;

  return (
    <div className={classes.titleRow}>
      <h3 className={classes.title}>Subscription Management</h3>
      <div className={classes.controlBlock}>
        <LbInput
          {...generalInputProps}
          name="generalFilter.name"
          placeholder="Search by name"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <SearchRoundedIcon fontSize="large" color="tertiary" />
              </InputAdornment>
            ),
          }}
        />
        <LbSelect
          {...generalInputProps}
          name="generalFilter.billingPeriodType"
          options={billingPeriodTypeOptionsWithAll}
          displayEmpty
        />
        <Button
          variant="contained"
          size="small"
          onClick={toggleShowCreateSubscriptionModal}
        >
          New Subscription
        </Button>
      </div>
    </div>
  );
};

export { TitleFilterRow };
